import React from 'react';
import BookingForm from '../components/BookingForm';

const BookingPage = ({ onBookingComplete, preselectService, onClearPreselect, currentUser, onNavigate }) => {
return (
<div className="pt-20">
<div className="relative py-20" style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)' }}>
<div className="absolute top-0 left-0 w-full h-1" style={{ background: 'linear-gradient(90deg, transparent, #C9A84C, transparent)' }}/>
<div className="text-center text-white px-4">
<p className="text-sm font-bold tracking-widest mb-3" style={{ color: '#C9A84C' }}>BOKA STÄDNING</p>
<h1 className="text-4xl md:text-5xl font-bold mb-4">
Boka Din <span style={{ color: '#C9A84C' }}>Elite Städning</span>
</h1>
<p style={{ color: 'rgba(255,255,255,0.7)' }}>Snabbt, enkelt och med 50% RUT-avdrag</p>
</div>
</div>
<BookingForm
onBookingComplete={onBookingComplete}
preselectService={preselectService}
onClearPreselect={onClearPreselect}
currentUser={currentUser}
onNavigate={onNavigate}
/>
</div>
);
};

export default BookingPage;